<template>
  <div class="fenxiao-team">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>我的团队</h2>
    </div>

    <!-- 分类选项卡 -->
    <div class="team-category">
      <div 
        v-for="(item, index) in category" 
        :key="index"
        class="category-item"
        :class="{ active: selectId === item.id }"
        v-if="index < levelNum"
        @click="selectCategory(item.id)"
      >
        {{ item.name }}
      </div>
    </div>

    <!-- 团队列表 -->
    <div class="team-list">
      <div 
        v-for="(item, index) in teamList" 
        :key="index"
        class="team-item"
      >
        <div class="member-avatar">
          <img 
            :src="item.headimg ? $util.img(item.headimg) : $util.img('/upload/default/default_img/head.png')" 
            @error="handleImageError(index)"
            alt="头像"
          />
        </div>
        <div class="member-info">
          <div class="member-header">
            <div class="member-left">
              <span class="member-name">
                {{ item.is_fenxiao ? item.fenxiao_name : item.nickname }}
              </span>
              <span 
                v-if="item.is_fenxiao && item.level_name" 
                class="member-level"
              >
                {{ item.level_name }}
              </span>
            </div>
            <div class="member-time">
              {{ item.is_fenxiao ? item.audit_time : item.reg_time }}
            </div>
          </div>
          <div class="member-stats">
            <div class="stat-item">
              <span class="stat-label">消费：</span>
              <span class="stat-value">{{ item.order_money }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">订单：</span>
              <span class="stat-value">{{ item.order_num }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="teamList.length === 0 && !loading" class="empty-state">
        <div class="empty-content">
          <i class="el-icon-user"></i>
          <p v-if="selectId === 0">暂无{{ category[0].name }}</p>
          <p v-else-if="selectId === 1">暂无一级分销员</p>
          <p v-else-if="selectId === 2">暂无二级分销员</p>
        </div>
      </div>

      <!-- 加载更多 -->
      <div v-if="loading" class="loading">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper" v-if="total > 0">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import { fenxiaoTeam, fenxiaoConfig } from '@/api/fenxiao/fenxiao'

export default {
  name: 'FenxiaoTeam',
  data() {
    return {
      category: [
        {
          id: 0,
          name: '推荐'
        }
      ],
      selectId: 0,
      teamList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      levelNum: 3
    }
  },
  mounted() {
    this.initCategoryNames()
    this.getFenxiaoLevel()
    this.getTeamList()
  },
  methods: {
    // 初始化分类名称
    initCategoryNames() {
      const type = this.$route.query.type
      if (type === '1') {
        this.category[0].name = '推荐供应商'
      } else if (type === '0') {
        this.category[0].name = '推荐采购商'
      } else {
        this.category[0].name = '推荐会员'
      }
    },

    // 选择分类
    selectCategory(id) {
      this.selectId = id
      this.currentPage = 1
      this.getTeamList()
    },

    // 获取团队列表
    async getTeamList() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          level: this.selectId,
          type : this.$route.query.type ?? 0
        }
        
        const response = await fenxiaoTeam(params)
        
        if (response.code === 0 && response.data) {
          this.teamList = response.data.list || []
          this.total = response.data.total || 0
          
          // 格式化时间
          this.teamList.forEach(item => {
            if (item.audit_time) {
              item.audit_time = this.formatTime(item.audit_time)
            }
            if (item.reg_time) {
              item.reg_time = this.formatTime(item.reg_time)
            }
          })
        } else {
          this.$message.error(response.message || '获取团队列表失败')
        }
      } catch (error) {
        console.error('获取团队列表失败:', error)
        this.$message.error('获取团队列表失败')
      } finally {
        this.loading = false
      }
    },

    // 获取分销等级配置
    async getFenxiaoLevel() {
      try {
        const response = await fenxiaoConfig()
        if (response.code === 0 && response.data) {
          this.levelNum = Number(response.data.level) || 3
        }
      } catch (error) {
        console.error('获取分销配置失败:', error)
      }
    },

    // 处理图片加载错误
    handleImageError(index) {
      this.$set(this.teamList, index, {
        ...this.teamList[index],
        headimg: '/upload/default/default_img/head.png'
      })
    },

    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toISOString().substring(0, 10)
    },

    // 分页切换
    handlePageChange(page) {
      this.currentPage = page
      this.getTeamList()
    }
  }
}
</script>

<style lang="scss" scoped>
.fenxiao-team {
  padding: 20px;
  background: #f5f5f5;
  min-height: calc(100vh - 60px);

  .page-header {
    margin-bottom: 20px;
    
    h2 {
      color: #333;
      font-size: 24px;
      font-weight: 500;
      margin: 0;
    }
  }

  .team-category {
    display: flex;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .category-item {
      flex: 1;
      padding: 15px 20px;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      color: #666;
      border-bottom: 3px solid transparent;
      transition: all 0.3s ease;

      &:hover {
        color: #409eff;
        background: #f0f8ff;
      }

      &.active {
        color: #409eff;
        border-bottom-color: #409eff;
        background: #f0f8ff;
      }
    }
  }

  .team-list {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    min-height: 400px;

    .team-item {
      display: flex;
      padding: 20px;
      border-bottom: 1px solid #f0f0f0;
      transition: background 0.3s ease;

      &:hover {
        background: #f9f9f9;
      }

      &:last-child {
        border-bottom: none;
      }

      .member-avatar {
        margin-right: 15px;

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #f0f0f0;
        }
      }

      .member-info {
        flex: 1;

        .member-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .member-left {
            display: flex;
            align-items: center;

            .member-name {
              font-size: 16px;
              font-weight: 500;
              color: #333;
              margin-right: 10px;
            }

            .member-level {
              padding: 2px 8px;
              background: #409eff;
              color: #fff;
              font-size: 12px;
              border-radius: 12px;
            }
          }

          .member-time {
            font-size: 12px;
            color: #999;
          }
        }

        .member-stats {
          display: flex;
          gap: 30px;

          .stat-item {
            font-size: 14px;

            .stat-label {
              color: #666;
            }

            .stat-value {
              color: #333;
              font-weight: 500;
            }
          }
        }
      }
    }

    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;

      .empty-content {
        text-align: center;
        color: #999;

        i {
          font-size: 48px;
          margin-bottom: 10px;
          display: block;
        }

        p {
          font-size: 14px;
          margin: 0;
        }
      }
    }

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      color: #666;

      i {
        margin-right: 8px;
      }
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>